import React, { useLayoutEffect, useRef } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import 'style/layout/Forms.css';

export default ({
  className,
  disabled,
  id,
  label,
  name,
  onChange,
  required,
  value,
}: {
  className?: string;
  disabled?: boolean;
  id: string;
  label: string;
  name?: string;
  onChange?: any;
  required?: boolean;
  value: string | number;
}): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null);

  useLayoutEffect(() => {
    const currentInputRef = inputRef.current;

    const keydownEvent = (event: KeyboardEvent) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.stopPropagation();
      }
    };

    currentInputRef?.removeEventListener('keydown', keydownEvent);
    currentInputRef?.addEventListener('keydown', keydownEvent);

    return () => {
      currentInputRef?.removeEventListener('keydown', keydownEvent);
    };
  });

  return (
    <FormGroup>
      <Label className="label" for={id}>
        {label}
      </Label>
      <Input
        className={`text-field ${className}`}
        disabled={disabled}
        id={id}
        name={name}
        onChange={onChange}
        innerRef={inputRef}
        required={required === undefined ? false : required}
        type="text"
        value={value}
      />
    </FormGroup>
  );
};
